import { useId } from "react";

import { FormField } from "~/components/ui/form-field";
import { Textarea } from "~/components/ui/textarea";

import { useFieldContext } from "./field-context";
import { useFieldError } from "./field-errors";

export function TextareaField({
  label,
  placeholder,
  required,
  helpText,
  rows = 4,
  maxLength,
}: {
  label?: string;
  placeholder?: string;
  required?: boolean;
  helpText?: string;
  rows?: number;
  maxLength?: number;
}) {
  const field = useFieldContext<string | null | undefined>();
  const error = useFieldError(field.name);
  const id = useId();
  return (
    <FormField
      inputId={id}
      label={label}
      required={required}
      helpText={helpText}
      error={error}
    >
      <Textarea
        id={id}
        rows={rows}
        maxLength={maxLength}
        placeholder={placeholder}
        value={field.state.value ?? ""}
        onValueChange={field.handleChange}
        onBlur={field.handleBlur}
      />
    </FormField>
  );
}
